import React from 'react'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state/index';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';

import {
  ToggleOffOutlined as ToggleOffOutlinedIcon
} from '@material-ui/icons';

import Tooltip from '@material-ui/core/Tooltip'
import { withStyles } from '@material-ui/core/styles';
import './styles.css'
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';


const styles = theme => ({
  papper: {
    minWidth: '300px',
  },
  rootDialog: {
    zIndex: 1505,
  },
  rootContent: {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '-5px 4px 10px #8E8E8E29',
    borderRadius: '21px',
    opacity: 1,
    maxWidth: '850px',
    minWidth: '290px',
    padding: '0px !important',
    overflow: 'hidden',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
})

const ItemSucursal = ({ sucursal, cantIconos, imagen, opciones, onClick }) => {
  return (
    <div className='containerItemSucursal' id='containerItemSucursal'>
      <Row>
        <Col xs={10} onClick={onClick} className='containerDatos' style={{ display: 'flex' }} id='colDatosSucursal'>
          {(imagen !== undefined) &&
            <img alt="" src={imagen} className='imgSucursal' id='imagenSucursal' />}
          <div>
            <div className='labelNombre' id='nombreSucursal'>{sucursal.nombre}</div>
            <div className='labelDescripcion' id='direccionSucursal'>{sucursal.direccion}</div>
            <div className='labelDescripcion' id='telefonoSucursal'>{sucursal.telefono}</div>
          </div>
        </Col>
        <Col xs={2} className='iconMenu' id='colMenuIconos'>
          <Col>
            <Row
              style={{
                marginLeft: (cantIconos === 3) ? '-25px' :
                  (cantIconos === 2) ? '-10px' :
                    (cantIconos === 1) ? '5px' :
                      '0px'
              }}
            >
              {(sucursal.activo !== true) && <Col sm={2} className='iconContainer' id='colIconoInactivo'><Tooltip title="Sucursal inactiva" placement="top"><ToggleOffOutlinedIcon className='icon_inactive' id='iconoInactivo' /></Tooltip></Col>}
              <Col sm={10}>
                <PopupState variant="popover" popupId={"nuevo-usuario-menu"} id='popupStateMenu'>
                  {popupState => (
                    <React.Fragment>
                      <IconButton {...bindTrigger(popupState)} id='iconoMenu'>
                        <MoreVertIcon />
                      </IconButton>
                      <Menu {...bindMenu(popupState)} id='menuOpciones'>
                        {opciones.map((x, index) => (
                          x !== undefined ? <MenuItem key={index} onClick={(...args) => { x.handler(...args); popupState.close(...args) }} id={`opcion-${index}`}>{x.nombre}</MenuItem> : undefined
                        ))}
                      </Menu>
                    </React.Fragment>
                  )}
                </PopupState>
              </Col>
            </Row>
          </Col>
        </Col>
      </Row>
    </div>
  )
}

const SucursalesListado = ({
  sucursales,
  mapToItem,
  openModalConfirm,
  handleOnCloseConfirmacion,
  mensajeConfirmacion,
  botonOk,
  setHandleOkActivar,
  classes,
  handleOnSearch
}) => {


  return (
    <div>
      <TitleBar
        title='Sucursales'
        searchPlaceholder='Ingrese nombre'
        newButtonLink='/Sucursales/Edit/0'
        showSearch={true}
        handleOnSearch={handleOnSearch}
        searchEmpty={true}

      />

      <Paper style={{ backgroundColor: "transparent", boxShadow: 'none' }}>
        <div>
          <Row>
            {sucursales && sucursales.map((x, i) =>
              <Col sm={12} md={6} lg={4} style={{ margin: '5px 0px' }}>
                <ItemSucursal {...mapToItem(x)} />
              </Col>)}
          </Row>
        </div>
      </Paper>

      {/** confirmacion */}
      <Dialog
        classes={{ root: classes.rootDialog, paperScrollPaper: classes.rootContent }}
        id="ecommerce"
        disableBackdropClick={true}
        fullWidth={true}
        maxWidth={'sm'}
        open={openModalConfirm}
        onClose={handleOnCloseConfirmacion}>
        <div className='containerModalConfirmacion'>
          <div className='labelModalConfirmacion'>{mensajeConfirmacion}</div>
          <div className='containerBtnConfirmacion'>
            <Button style={{ marginRight: "12px" }} className="btnSecundario" onClick={() => handleOnCloseConfirmacion()} >Cancelar</Button>
            {
              (botonOk.map) ?
                botonOk.map((x, i) =>
                  <Button variant="contained" className="btnPrincipalAux btnPrincipal btnPrincipalAuxMargin" onClick={() => { setHandleOkActivar(); handleOnCloseConfirmacion(); }}>{botonOk[i]}</Button>
                )
                : <Button variant="contained" className="btnPrincipalAux btnPrincipal" onClick={() => { setHandleOkActivar(); handleOnCloseConfirmacion(); }}>{botonOk}</Button>
            }
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default withStyles(styles)(SucursalesListado);